/* cjl-amazon — ventana "también en Amazon" + pestaña fija (sections/cjl-amazon.liquid).
   Se abre al dejar atrás #cjl-familias (data-trigger="after_familias"), al recorrer data-scroll % de la página ("scroll")
   o tras data-delay s ("time").
   Estado por visita en sessionStorage:
     cjl-amz-seen = la ventana ya se abrió sola → en las siguientes páginas solo sale la pestaña
     cjl-amz-off  = cerraron la pestaña con su X → no vuelve en esta visita */
(function () {
  var root = document.querySelector('[data-cjl-amz]');
  if (!root || root.dataset.cjlAmzReady) return;
  root.dataset.cjlAmzReady = '1';

  var modal = root.querySelector('[data-cjl-amz-modal]');
  var dock = root.querySelector('[data-cjl-amz-dock]');
  var opener = root.querySelector('[data-cjl-amz-open]');
  if (!modal || !dock || typeof modal.showModal !== 'function') return;

  var SEEN = 'cjl-amz-seen', OFF = 'cjl-amz-off', DURATION = 350;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var store = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k) { try { sessionStorage.setItem(k, '1'); } catch (e) {} }
  };

  function showDock() { if (!store.get(OFF)) dock.classList.add('is-in'); }
  function hideDock() { dock.classList.remove('is-in'); }

  function open() {
    if (modal.open) return;
    hideDock();
    document.documentElement.classList.add('cjl-amz-lock');
    if (!reduce) modal.classList.add('is-opening');
    modal.showModal();
    store.set(SEEN);
    if (!reduce) requestAnimationFrame(function () {
      requestAnimationFrame(function () { modal.classList.remove('is-opening'); });
    });
  }

  function close() {
    if (!modal.open || modal.classList.contains('is-closing')) return;
    var done = function () {
      modal.classList.remove('is-closing');
      modal.close();
      document.documentElement.classList.remove('cjl-amz-lock');
      showDock();
      if (dock.classList.contains('is-in')) opener.focus({ preventScroll: true });
    };
    if (reduce) return done();
    modal.classList.add('is-closing');
    setTimeout(done, DURATION);
  }

  opener.addEventListener('click', open);
  root.querySelector('[data-cjl-amz-close]').addEventListener('click', close);
  root.querySelector('[data-cjl-amz-hide]').addEventListener('click', function () { store.set(OFF); hideDock(); });
  modal.addEventListener('cancel', function (e) { e.preventDefault(); close(); }); /* Esc: misma salida animada */
  modal.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });

  var foot = document.getElementById('section-footer');
  if (foot && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      dock.classList.toggle('is-away', entries[0].isIntersecting);
    }).observe(foot);
  }

  if (design) {
    showDock();
    document.addEventListener('shopify:section:select', function (e) { if (e.detail.sectionId === root.dataset.sectionId) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.detail.sectionId === root.dataset.sectionId) close(); });
    return;
  }

  if (root.dataset.auto !== 'true' || store.get(SEEN)) { showDock(); return; }

  /* si hay un cajón o ventana de Eurus abierto (carrito, menú…), espera y reintenta */
  function busy() { return document.body.classList.contains('overflow-hidden') || document.querySelector('dialog[open]'); }
  function tryOpen(wait) {
    setTimeout(function () {
      if (store.get(SEEN)) { showDock(); return; }
      if (busy()) return tryOpen(5000);
      open();
    }, wait);
  }

  /* "after_familias": se abre cuando el final de Four families sube a la mitad de la pantalla
     (la sección siguiente ya ocupa media pantalla). Sin esa sección en la página → cae al porcentaje. */
  var fam = root.dataset.trigger === 'after_familias' && document.getElementById('cjl-familias');
  if (fam) {
    var onPass = function () {
      if (fam.getBoundingClientRect().bottom > window.innerHeight * 0.5) return;
      window.removeEventListener('scroll', onPass);
      tryOpen(0);
    };
    window.addEventListener('scroll', onPass, { passive: true });
    return;
  }

  if (root.dataset.trigger === 'scroll' || root.dataset.trigger === 'after_familias') {
    /* se abre cuando el borde de abajo de la pantalla pasa el `scroll_pct` % del alto total de la página */
    var pct = (parseInt(root.dataset.scroll, 10) || 50) / 100;
    var onScroll = function () {
      var doc = document.documentElement;
      if ((window.scrollY + window.innerHeight) / doc.scrollHeight < pct) return;
      window.removeEventListener('scroll', onScroll);
      tryOpen(0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return;
  }

  tryOpen((parseInt(root.dataset.delay, 10) || 15) * 1000);
})();
